import React from "react";

import { useSelector } from "react-redux";

import NewsCategoryListViewDesktop from "./news-category-list-view-desktop";
import NewsCategoryListViewTablet from "./news-category-list-view-tablet";
import NewsCategoryListViewPhone from "./news-category-list-view-phone";

import ResponsiveWrapper from "../../shared-components/responsive-wrapper";

const NewsCategoryListController = ({
  categories,
  location,
  currentNewsCategory,
}) => {
  const locale = useSelector(state => {
    return state.localeReducer.locale;
  }, []);

  return (
    <ResponsiveWrapper
      DesktopComponent={
        <NewsCategoryListViewDesktop
          locale={locale}
          data={categories}
          location={location}
          currentNewsCategory={currentNewsCategory}
        />
      }
      TabletComponent={
        <NewsCategoryListViewTablet
          locale={locale}
          data={categories}
          location={location}
          currentNewsCategory={currentNewsCategory}
        />
      }
      PhoneComponent={
        <NewsCategoryListViewPhone
          locale={locale}
          data={categories}
          location={location}
          currentNewsCategory={currentNewsCategory}
        />
      }
    />
  );
};

export default NewsCategoryListController;
